import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root"
  })
  export class FilterStateService {
    state$ = new BehaviorSubject<any>(null);
  }